import React from "react";
import classNames from "classnames";

import Conditional from "../../../common/conditional";
import CustomSection from "../../custom-general/custom-section";
import ParseHTML from "../../../common/ParseHTML";
import PDFTablePage from "../../../themed/pdf/pdfTablePage";
import PAUTConstraint from "../../custom-paut/paut-constraint";

import { LRUTDataItem } from "../lrutDataItems";

import styles from './style.module.scss';

interface Props {
    dataItems: LRUTDataItem[];
}

const LRUTWaveItems: React.FC<Props> = ({ dataItems }) => {
    return ( 
        <>
            {dataItems.map((item) => (
                <CustomSection key={item.id} sectionTitle="LRUT / GUL Data Page" sectionSubtitle="Scan Data">
                    <div className={classNames(["p-1", styles.summary])}>
                        <PDFTablePage data={[item]} columns={columns} />

                        <Conditional isVisible={item.aScan.length === 0 && item.cScan.length === 0}>
                            <PAUTConstraint />
                        </Conditional>

                        {item.aScan.length > 0 && (
                            <div className={classNames(["mt-1", styles.summaryScan])}>
                                <div className={classNames(["p-1", styles.summaryScanHeader])}>
                                    <p>A-SCAN</p>
                                </div>
                                <div className={styles.summaryScanBody}>
                                    <img src={item.aScan[0].src} alt={item.aScan[0].caption} />
                                </div>
                            </div>
                        )}
                        
                        {item.cScan.length > 0 && (
                            <div className={classNames(["mt-1", styles.summaryScan])}>
                                <div className={classNames(["p-1", styles.summaryScanHeader])}>
                                    <p>C-SCAN</p>
                                </div>
                                <div className={styles.summaryScanBody}>
                                    <img src={item.cScan[0].src} alt={item.cScan[0].caption} />
                                </div>
                            </div>
                        )}

                        <div className="container-fluid mt-1">
                            <div className="row gap-1">
                                <div className={classNames(["col", styles.summaryContainer])}>
                                    <p className={styles.summaryContainerHeader}>
                                        Notes:
                                    </p>
                                    <p>
                                        <ParseHTML text={item.notes} />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </CustomSection>
            ))}
        </>
    );
};

const columns = [
    {
        path: 'shotNumber',
        label: 'GUL Shot Number',
    },
    {
        path: 'feature',
        label: 'Feature',
    },
    {
        path: 'location',
        label: 'Location (M)',
    },
    {
        path: 'ecl',
        label: 'ECL',
    },
    {
        path: 'length',
        label: 'Length (mm)',
    },
    {
        path: 'extent',
        label: 'Extent (deg)',
    },
    {
        path: 'class',
        label: 'Class',
    },
    {
        path: 'scanDirection',
        label: 'Scan Direction',
    },
];

export default LRUTWaveItems;